<!-- Service -->
<template>
  <div class="Service">
    <HelloWorld />
    <div class="tup">
      <img src="../assets/image/banner4.png" alt />
    </div>
    <div class="lianxi360">
      <div class="lianxi3601">
        <h2>360°全方位一站式服务</h2>
        <div class="xinxi">
          <!-- <img src="../assets/image/yizhanshi.png" alt /> -->
          <div class="d1">
            <img src="../assets/image/yizhanshi1.png" alt />
            <h4>专业客服答疑</h4>
            <p>7*12小时专业指导 解答疑惑</p>
          </div>
          <div class="d2">
            <img src="../assets/image/yizhanshi2.png" alt />
            <h4>线上一对一视频指导</h4>
            <p>实施工程师线上线下一对一教学，随时提升能力</p>
          </div>
          <div class="d3">
            <img src="../assets/image/yizhanshi3.png" alt />
            <h4>专业定制</h4>
            <p>支持全方位专业定制，为您的店铺量身打造</p>
          </div>
          <div class="d4">
            <img src="../assets/image/yizhanshi4.png" alt />
            <h4>行业交流活动</h4>
            <p>微信、直播、社区、商盟，实战分享</p>
          </div>
        </div>
      </div>
    </div>
    <div class="tixi" id="a1">
      <div class="tixi1">
        <h2>服务体系</h2>
        <p>专业服务团队，全程陪伴，助你成长</p>
        <div class="xinxi">
          <div class="xinxiz">
            <img src="../assets/image/shangjiafuwu.jpg" alt />
          </div>
          <div class="xinxiy">
            <img src="../assets/image/shangjiashishi.jpg" alt />
          </div>
        </div>
        <div id="a2"></div>
      </div>
    </div>
    <div class="piexun">
      <h2>中关村商学院</h2>
      <div class="piexun1">
        <div>
          <img src="../assets/image/shalong.png" alt />
        </div>
        <div>
          <img src="../assets/image/zhibo.png" alt />
        </div>
        <div>
          <img src="../assets/image/peixun.png" alt />
        </div>
      </div>
      <div id="a3"></div>
      <h3>实施案例</h3>
      <div class="piexun2">
        <div>
          <img src="../assets/image/logo4.png" alt class="img" />
          <h3>平顶山市迪信通商贸有限公司</h3>
          <p class="pp1">手机零售/批发行业</p>
          <p class="pp2">改变了传统批发方式，以往需要打电话订货，低效耗时，现在客户只需要打开分销APP就能随时随地在线订货，非常方便。</p>
          <!-- <img src="../assets/image/dxintong.png" alt /> -->
        </div>
        <div>
          <img src="../assets/image/logo3.png" alt class="img" />
          <h3>河南华莲通讯科技有限公司</h3>
          <p class="pp1">手机批发行业</p>
          <p class="pp2">客户只需要扫描二维码就能在我的平台采购，这在以前根本就不敢想。通过移动开单和复合收银、智能进销存管理等功能，完成“从货到人”的服务思维转型。</p>
          <!-- <img src="../assets/image/dxintong.png" alt /> -->
        </div>
        <div>
          <img src="../assets/image/logo2.png" alt class="img" />
          <h3>西安荣合通讯器材有限公司</h3>
          <p class="pp1">手机批发行业</p>
          <p class="pp2">经常会有多个商品打包批发的需求，分销版正好有这个功能，而且非常好用。管理数据化了，人效自然提升，业绩自然能有效提升。</p>
          <!-- <img src="../assets/image/dxintong.png" alt /> -->
        </div>
        <div>
          <img src="../assets/image/logo1.png" alt class="img" />
          <h3>凡贝科技有限公司</h3>
          <p class="pp1">手机批发行业</p>
          <p class="pp2">一款好的零售软件，应该让管理事半功倍，更应该帮助零售商实现从传统的进销存管理到新零售数字化的转型升级。这些，凡贝科技通过智选云商系统实现了!</p>
          <!-- <img src="../assets/image/dxintong.png" alt /> -->
        </div>
      </div>
    </div>
    <!-- <Footer /> -->
    <div class="footer">
      <div class="footer1">
        <div class="footer1-1">
          <h3>
            <img src="../assets/image/rexianicon.png" alt /> 合作热线
          </h3>
          <h2>15617953373</h2>
          <p>全国服务时间：</p>
          <p>周一至周日 9:00-18:00</p>
        </div>
        <div class="footer1-2">
          <div class="footer1-21">
            <h4>产品</h4>
            <!-- <router-link to="/products"><p @click="lista12(1)">零售版</p></router-link>
            <router-link to="/products"><p @click="lista12(2)">分销版</p></router-link>-->
            <router-link to="/product">
              <p>零售版</p>
            </router-link>
            <router-link to="/product/products2">
              <p>分销版</p>
            </router-link>
          </div>
          <div class="footer1-22">
            <div class="footer1-21">
              <h4>服务</h4>
              <a href="#a1">
                <p>服务与实施</p>
              </a>
              <a href="#a2">
                <p>中关村商学院</p>
              </a>
              <a href="#a3">
                <p>实施案例</p>
              </a>
            </div>
          </div>
          <div class="footer1-23">
            <div class="footer1-21">
              <h4>价格</h4>
              <router-link to="/price">
                <p>价格列表</p>
              </router-link>
            </div>
          </div>
          <div class="footer1-24">
            <div class="footer1-21">
              <h4>关于我们</h4>
              <router-link to="/about">
                <p>公司简介</p>
              </router-link>
              <router-link to="/about">
                <p>联系我们</p>
              </router-link>
              <p></p>
            </div>
          </div>
        </div>
        <div class="footer1-3">
          <div class="footer1-31">
            <p>订阅号</p>
            <img src="../assets/image/dingyuehao@2x.png" alt />
            <br />
            <!-- <br /> -->
            <p>ZOL智选云商</p>
          </div>
          <div class="footer1-3x"></div>
          <div class="footer1-32">
            <p>服务号</p>
            <img src="../assets/image/fuwuhao1@2x.png" alt />
            <br />
            <!-- <br /> -->
            <p>ZOL智选云商</p>
          </div>
          <div class="footer1-33">
            <p>服务号</p>
            <img src="../assets/image/fuwuhao2@2x.png" alt />
            <br />
            <!-- <br /> -->
            <p>科技智能手机终端</p>
          </div>
        </div>
      </div>
      <div class="xian"></div>
      <div class="di1">
        <div class="di11">
          <p>Copyright © 2017-2020 智选云商 豫ICP备2021018472号-1</p>
        </div>
        <div class="di12">
          <p></p>
        </div>
        <div class="di13">
          <p>公司地址：河南省郑州市紫荆山路57号裕鸿国际C座1606室</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import HelloWorld from "@/components/top-header";
// import Footer from "@/components/footer";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    HelloWorld,
    // Footer,
  },
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.tup {
  width: 100%;
  // height: 420px;
  margin: 0px auto;
  margin-top: 70px;
  img {
    width: 100%;
    // height: 420px;
  }
  // border: 1px solid red;
}
.lianxi360 {
  height: 380px;
  width: 100%;
  .lianxi3601 {
    height: 380px;
    width: 1033px;
    margin: 0px auto;
    // border: 1px solid red;
    h2 {
      font-size: 32px;
      color: #333333;
      text-align: center;
      margin-top: 62px;
    }

    .xinxi {
      width: 1033px;
      height: 200px;
      margin: 0px auto;
      margin-top: 56px;
      // border: 1px solid red;
      // img {
      //   width: 100%;
      // }
      display: flex;
      justify-content: space-between;
      .d1 {
        width: 155px;
      }
      .d1,
      .d2,
      .d3,
      .d4 {
        height: 200px;
        // border: 1px solid red;
        text-align: center;
        img {
          width: 121px;
          height: 121px;
        }
        h4 {
          margin-top: 20px;
          font-size: 18px;
          color: #2c3946;
        }
        p {
          margin-top: 10px;
          font-size: 12px;
          color: #999999;
        }
      }
      .d2 {
        width: 257px;
      }
      .d3 {
        width: 233px;
      }
      .d4 {
        width: 197px;
      }
    }
  }
}
.tixi {
  height: 510px;
  width: 100%;
  background-color: #f3f6ff;
  .tixi1 {
    height: 510px;
    width: 1033px;
    margin: 0px auto;
    // border: 1px solid red;
    padding-top: 60px;
    h2 {
      font-size: 32px;
      color: #333333;
      text-align: center;
      // margin-top: 60px;
    }
    p {
      font-size: 16px;
      text-align: center;
      color: #666666;
    }
    .xinxi {
      width: 1033px;
      height: 276px;
      margin: 0px auto;
      margin-top: 38px;
      .xinxiz {
        width: 485px;
        height: 276px;
        padding-left: 45px;
        float: left;
        img {
          width: 100%;
        }
      }
      .xinxiy {
        width: 485px;
        height: 276px;
        padding-right: 45px;
        float: right;
        img {
          width: 100%;
        }
      }
    }
  }
}
.piexun {
  width: 1100px;
  height: 1190px;
  margin: 0px auto;
  // border: 1px solid red;
  margin-bottom: 110px;
  h2 {
    font-size: 32px;
    margin-top: 68px;
    margin-bottom: 34px;
    text-align: center;
    color: #333333;
  }
  .piexun1 {
    width: 100%;
    height: 524px;
    display: flex;
    justify-content: space-between;
    div {
      width: 350px;
      height: 524px;
      img {
        width: 100%;
      }
    }
  }
  h3 {
    margin-top: 84px;
    font-size: 32px;
    margin-bottom: 34px;
    text-align: center;
    color: #333333;
  }
  .piexun2 {
    width: 100%;
    height: 380px;
    display: flex;
    justify-content: space-between;
    div {
      height: 380px;
      width: 260px;
      background-color: #f2f2f2;
      text-align: center;
      .img {
        margin-top: 30px;
        margin-bottom: 25px;
        border-radius: 50%;
      }
      h3 {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
      }
      .pp1 {
        color: #a0a0a0;
        margin-bottom: 20px;
      }
      .pp2 {
        padding-left: 20px;
        padding-right: 20px;
        text-align: left;
        color: #7e7e7e;
      }
    }
  }
}
.footer {
  width: 100%;
  height: 300px;
  background-color: #272b2e;
  .footer1 {
    width: 1200px;
    height: 200px;
    margin: 0px auto;
    // border: 1px solid red;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    .footer1-1 {
      width: 190px;
      // border: 1px solid red;
      height: 160px;
      h3 {
        color: #ffffff;
        font-size: 18px;
        margin: 0;
        img {
          padding-bottom: 15px;
        }
      }
      h2 {
        color: #ffffff;
        margin: 0;
        font-size: 30px;
        margin-bottom: 20px;
        margin-bottom: 5px;
        margin-top: -5px;
      }
      p {
        color: #999999;
        font-size: 14px;
        margin: 5px 0px;
      }
    }
    .footer1-2 {
      width: 500px;
      // border: 1px solid red;
      height: 160px;
      display: flex;
      justify-content: space-between;
      .footer1-21 {
        width: 100px;
        height: 160px;
        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
          color: #999999;
        }
        a {
          color: #999999;
          text-decoration: none;
        }
      }
      .footer1-22 {
        width: 85px;
        height: 160px;
        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
          color: #999999;
        }
      }
      .footer1-23 {
        width: 86px;
        height: 160px;
        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
          color: #999999;
        }
      }
      .footer1-24 {
        width: 57px;
        height: 160px;
        h4 {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 20px;
        }
        p {
          font-size: 14px;
          color: #999999;
        }
      }
      a:hover p {
        color: white;
        z-index: 99999;
      }
    }
    .footer1-3 {
      width: 350px;
      height: 160px;
      // border: 1px solid red;
      display: flex;
      justify-content: space-between;
      .footer1-3x {
        width: 2px;
        height: 128px;
        margin-top: 18px;
        margin-right: 5px;
        // padding: 10px 0px;
        // padding-right: 20px;
        border-right: 1px solid #4e5357;
      }
      .footer1-31 {
        width: 100px;
        height: 160px;
        p {
          font-size: 12px !important;
          color: #ffffff;
          text-align: center;
          margin: 7px 0px;
        }
        img {
          width: 95px;
          height: 95px;
        }
      }
      .footer1-32 {
        width: 100px;
        height: 160px;
        p {
          font-size: 12px !important;
          color: #ffffff;
          text-align: center;
          margin: 7px 0px;
        }
        img {
          width: 95px;
          height: 95px;
        }
      }
      .footer1-33 {
        width: 120px;
        height: 160px;
        //  border: 1px solid red;
        p {
          font-size: 12px !important;
          color: #ffffff;
          text-align: center;
          margin: 7px 0px;
        }
        img {
          margin-left: 10px;
          width: 95px;
          height: 95px;
        }
      }
    }
  }
  .xian {
    width: 1200px;
    height: 0px;
    margin: 0px auto;
    margin-top: 40px;
    border-top: 2px solid #404345;
  }
  .di1 {
    width: 1200px;
    margin: 0px auto;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    p {
      font-size: 12px;
      color: #999999;
    }
  }
}
@media screen and (max-width: 1200px) {
  .Service {
    width: 1200px;
    // border: 1px solid black;
    // height: 560px;
  }
}
</style>